import './anfragen.css';
import { useNavigate } from 'react-router-dom';
import { fmtDayMonth } from '../../lib/format';
import { useApi } from '../../lib/useApi';
import { Bar, type Row } from '../lohn/LohnBar';
import { AREA_LABEL, requestPath } from './labels';
import type { AnfragenBarResponse } from './types';

// Leiste „Anfragen aus der App“: Unterlagen, die Mandanten angefordert haben (meine Bereiche, die ältesten oben), bis
// jemand „Erledigt“ setzt. Erledigte erscheinen wieder, wenn der Mandant danach kommentiert. Ohne clientId alle
// Mandanten, sonst nur dieser.
export function AnfragenBar({ clientId }: { clientId?: string }) {
  const navigate = useNavigate();
  const res = useApi<AnfragenBarResponse>(`/api/kanzlei/anfragen${clientId ? `?clientId=${clientId}` : ''}`, {
    live: ['anfragen'],
  });
  const d = res.data;
  if (!d?.items.length) return null;

  const rows: Row[] = d.items.map((r) => ({
    key: r.id,
    go: () => navigate(requestPath(r.clientId, r.id)),
    tx: (
      <>
        <b>{r.label}</b>
        {r.employee && ` · ${r.employee.name}`}
        {!clientId && ` · ${r.clientName}`}
        {d.admin && r.who !== undefined && (
          <span className={`note${r.who ? '' : ' who-open'}`}>
            {' '}
            · {AREA_LABEL[r.area]}: {r.who ?? 'offen, bitte zuweisen'}
          </span>
        )}
        {r.unseen && (
          <>
            {' '}
            <span className="pill p-info">neu</span>
          </>
        )}
        {r.newComment && (
          <>
            {' '}
            <span className="pill p-warn">💬 neuer Kommentar</span>
          </>
        )}
        {r.status === 'offen' && r.files > 0 && (
          <>
            {' '}
            <span className="pill p-ok">Datei hochgeladen</span>
          </>
        )}
        <small>
          {r.note ? `Wunsch: „${r.note}“ · ` : ''}angefordert am {fmtDayMonth(r.createdAt)}
          {r.createdBy ? ` von ${r.createdBy}` : ''}
          {r.status === 'erledigt' && ' · schon erledigt'}
        </small>
      </>
    ),
  }));
  return (
    <Bar
      head={`📄 ${rows.length === 1 ? 'Anfrage aus der App' : `${rows.length} Anfragen aus der App`}`}
      rows={rows}
      className="anfbar"
    />
  );
}
